module.exports = __webpack_public_path__ + "img/Unidad17-5.1f3c6b0d.png";